<template>
  <v-chip
    :color="online ? onlineColor : 'rgba(120, 111, 96, 0.12)'"
    :text-color="online ? 'white' : '#7a6f60'"
    small
    class="presence-badge"
  >
    <span class="presence-dot" :class="{ 'presence-dot--online': online }"></span>
    {{ label }}
  </v-chip>
</template>

<script>
export default {
  name: 'BiblePresenceBadge',
  props: {
    label: {
      type: String,
      required: true,
    },
    online: {
      type: Boolean,
      default: false,
    },
    onlineColor: {
      type: String,
      default: '#6f8063',
    },
  },
};
</script>

<style scoped>
.presence-badge {
  border-radius: 999px !important;
  font-weight: 600;
  letter-spacing: 0;
}

.presence-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-right: 7px;
  background: #b8afa2;
}

.presence-dot--online {
  background: #dbe9d2;
  box-shadow: 0 0 0 3px rgba(219, 233, 210, 0.24);
}
</style>
